import React, { useState, useEffect, useRef } from "react";
import editIcon from "../../../../assets/images/editIcon02.png";
import saveIcon from "../../../../assets/images/Check.svg";
import clearIcon from "../../../../assets/images/X.svg";

const TextAreaField = ({
  name,
  id,
  placeholder,
  defaultValue,
  maxAllowed,
  minAllowed,
  onChange,
  required,
  showEditIcon = false,
  saveEdit,
  className,
  isEventPage = false,
  editSaveCustomStyle = "",
  editCustomStyle = "",
  label,
  onFieldBlur,
  onEditClick,
  onCancelEdit
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const [updatedVal, setUpdatedVal] = useState("");
  const [valLength, setValLength] = useState(defaultValue?.length || 0);
  const textareaRef = useRef(null);

  useEffect(() => {
    setValLength(defaultValue?.length || 0);
    setUpdatedVal(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    if (isEditable && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [isEditable]);

  const onInputChange = (e) => {
    const value = e.target.value;
    setValLength(value?.length);
    if (showEditIcon) {
      return setUpdatedVal(value);
    }
    onChange(e);
  };

  const onSaveEdit = () => {
    if (defaultValue === updatedVal) {
      setIsEditable(false);
    } else {
      saveEdit(id, updatedVal, true, name);
      setIsEditable(false);
    }
  };

  const handleCancel = async () => {
    setUpdatedVal(defaultValue);
    setIsEditable(false);
    if (onCancelEdit) await onCancelEdit();
  };

  const onBlur = (e) => {
    if (onFieldBlur && isEditable) {
      const next = e.relatedTarget;
      const isSaveOrCancel =
        next?.alt === "save edit" ||
        next?.alt === "clear edit" ||
        next?.closest(".save-cancel-wrapper");

      const clickedInsideSaveCancel =
        e.currentTarget.parentElement
          ?.querySelector(".save-cancel-wrapper")
          ?.contains(document.activeElement);

      if (!isSaveOrCancel && !clickedInsideSaveCancel) {
        onFieldBlur();
      }
    }
  };

  return (
    <div
      className={`flex flex-row ${showEditIcon ? `justify-between ${editCustomStyle}` : "justify-start"}`}
    >
      <div
        className={`flex flex-col h-20 overflow-auto w-full ${
          showEditIcon ? "justify-between" : "justify-start"
        }`}
      >
        <textarea
          ref={textareaRef}
          id={id}
          name={name}
          className={`text-sm placeholder-grayNobel text-tileGray font-normal mt-1 border-none w-full outline-none ${
            className || ""
          } ${
            isEventPage && showEditIcon && !isEditable && "cursor-pointer"
          }`}
          minLength={minAllowed}
          maxLength={maxAllowed}
          placeholder={placeholder}
          rows={10}
          cols={10}
          readOnly={showEditIcon && !isEditable}
          required={required}
          value={updatedVal}
          onChange={onInputChange}
          onClick={() => isEventPage && showEditIcon && setIsEditable(true)}
          onBlur={onBlur}
        />
        <p className="font-normal text-xs text-right w-full text-tileGray">
          {valLength}/{maxAllowed}
        </p>
      </div>

      {showEditIcon && !isEditable && (
        <button
          type="button"
          aria-label="edit"
          data-action="edit"
          className={`ml-ten -mt-16 ${editCustomStyle}`}
          onClick={() => {
            setIsEditable(true);
            if (onEditClick) onEditClick(label, true);
          }}
        >
          <img src={editIcon} alt="edit" className="h-4 w-4 cursor-pointer" />
        </button>
      )}

      {isEditable && (
        <div className={`grid -mt-5 ml-2 gap-2 h-fit save-cancel-wrapper ${editSaveCustomStyle}`}>
          <button
            type="button"
            aria-label="save edit"
            data-action="save"
            className="w-4 h-4 cursor-pointer"
            onClick={onSaveEdit}
          >
            <img src={saveIcon} alt="save edit" />
          </button>

          <button
            type="button"
            aria-label="clear edit"
            data-action="cancel"
            className="w-4 h-4 cursor-pointer"
            onClick={handleCancel}
          >
            <img src={clearIcon} alt="clear edit" />
          </button>
        </div>
      )}
    </div>
  );
};

export default TextAreaField;
